<template>
  <div class="login-container">
    <div
      v-if="!isVerify"
      class="card">
      <p class="set-password-title">Setup 2-Step Login</p>
      <div class="body">
        <p>1. Download the Google Authenticator App</p>
        <p>Go to your device’s app store (App Store/Google Play Store) and download the “Google Authenticator” app.</p>
      </div>
      <div class="body">
        <p>2. Add this account to Google Authenticator</p>
        <p>Open your Google Authenticator app and scan the QR code below.</p>
        <img
          :src="codeData"
        >
      </div>
      <div class="body">
        <p>3. Verify your account is properly setup in Google Authenticator</p>
        <p>Enter the verification code from Google Authenticator below.</p>
        <div class="form-item">
          <span>Verification Code from Google Authenticator</span>
          <v-input
            v-model="code"
            placeholder="6-digit code"
            @keyEnter="handleLogin" />
        </div>
      </div>
      <v-button
        type="success"
        @click="handleLogin">Confirm</v-button>
    </div>
    <div
      v-else
      class="card width-500">
      <p class="set-password-title">2-Step Login</p>
      <div class="form-item">
        <span>Enter the verification code from Google Authenticator</span>
        <v-input
          v-model="code"
          placeholder="6-digit code"
          maxlength="6"
          :keyNumber="true"
          :autofocus="true"
          @keyEnter="handleLogin" />
      </div>
      <v-button
        type="success"
        @click="handleLogin">Confirm</v-button>
    </div>
  </div>
</template>

<script>
import { getVerifyCode,secondLogin} from '@api/index'
import {mapState} from 'vuex'
export default {
  name: 'verify',
  data(){
    return {
      code:'',
      codeData:''
    }
  },
  computed:{
    ...mapState('verify',['isVerify'])
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        if(!this.isVerify)
          this.getVerifyCode()
      }
    }
  },
  mounted(){
    console.log(process.env.NODE_ENV)
    if(process.env.NODE_ENV == 'development'){
      this.code = '111111'
    }
  },
  methods: {
    handleLogin(){
      if(!this.code)
        return   this.$message({
          type: 'warning',
          message: '請輸入驗證碼'
        })
      this.network().login()
    },
    getVerifyCode() {
      this.network().getVerifyCode()
    },
    network() {
      return {
        getVerifyCode: async () => {
          const { data } = await getVerifyCode({
          })
          this.codeData = data.data
        },
        login:async ()=>{
          const { data } = await secondLogin({
            code: this.code
          })
          localStorage.setItem('isVerified',true)
          localStorage.setItem('token', data.access_token)
          localStorage.setItem('refresh_token', data.refresh_token)
          localStorage.setItem('auth', JSON.stringify(data))
          localStorage.setItem('agency_id', data.agency_id)
          // localStorage.setItem('cs_name', data.name)
          const { fullPath = '' } = this.$route.query
          if(fullPath) {
            this.$router.replace(fullPath)
          } else {
            this.$router.replace('/')
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  background: #fff;
  .card {
    padding: 100px 0;
    width: 500px;
    box-shadow: none;
    &.width-500{
      .form-item{
        width: 500px!important;
      }
      .el-button{
        margin-top: 40px;
        width: 100%;
      }
    }
    .set-password-title{
      font-weight: 600;
      font-size: 24px;
      line-height: 36px;
      letter-spacing: 0.3px;
      color: #24292E;
      text-align: left;
      margin-bottom: 40px;
    }
    .form-item {
      //margin: 0 auto;
      width: 330px;
      padding-bottom: 0px;
      & > span {
        text-align: left;
        &:first-child{
          padding-bottom: 8px;
        }
      }
    }
    .body{
      padding: 15px;
      position: static;
      width: 500px;
      background: #F6F8FA;
      border-radius: 6px;
      margin: 20px 0px;
      p{
        &:first-child{
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #24292E;
        }
        &:nth-child(2){
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          color: #24292E;
          margin: 15px 0px;
        }
      }

    }
    .el-button{
      width: 100%;
      margin-top: 10px;
      //font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      //display: flex;
      //align-items: center;
      letter-spacing: -0.15px;
      color: #FFFFFF;
      background: #2EA44F;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-sizing: border-box;
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
      border-radius: 6px;
      &--success:hover {
        background: #2EA44F;
        opacity: 0.8;
        border-color: rgba(27, 31, 35, 0.15);
      }
    }
  }
}
</style>
